import FaultAnalytics from './component'

export default FaultAnalytics